"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const GoogleMapsProvider_1 = require("./GoogleMapsProvider");
const GoogleMap = ({ center = { lat: 37.7749, lng: -122.4194 }, zoom = 12, markers = [], mapContainerStyle = { height: "100%", width: "100%" }, defaultIcon, styles = [], // Default to an empty array
onLoad, onUnmount, zoomControl = false, mapTypeControl = false, streetViewControl = false, fullscreenControl = false, }) => {
    const { isMapLoaded } = (0, react_1.useContext)(GoogleMapsProvider_1.GoogleMapsContext) || { isMapLoaded: false };
    const mapRef = (0, react_1.useRef)(null);
    const [map, setMap] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (isMapLoaded && mapRef.current && !map) {
            const mapInstance = new google.maps.Map(mapRef.current, {
                center,
                zoom,
                styles,
                zoomControl,
                mapTypeControl,
                streetViewControl,
                fullscreenControl,
            });
            // Call onLoad callback if provided
            if (onLoad) {
                onLoad(mapInstance);
            }
            setMap(mapInstance);
        }
        // Cleanup and call onUnmount callback when unmounting
        return () => {
            if (map && onUnmount) {
                onUnmount(map);
            }
        };
    }, [isMapLoaded, mapRef, map, center, zoom, onLoad, onUnmount, styles, zoomControl, mapTypeControl, streetViewControl, fullscreenControl]);
    (0, react_1.useEffect)(() => {
        if (map) {
            markers.forEach(({ position, content }) => {
                const marker = new google.maps.Marker({
                    position,
                    map,
                    icon: defaultIcon,
                });
                if (content) {
                    const infoWindow = new google.maps.InfoWindow({
                        content,
                    });
                    marker.addListener("click", () => infoWindow.open(map, marker));
                }
            });
        }
    }, [map, markers]);
    if (!isMapLoaded) {
        return react_1.default.createElement("div", null, "Loading Google Maps...");
    }
    return react_1.default.createElement("div", { ref: mapRef, style: mapContainerStyle });
};
exports.default = GoogleMap;
